import { useState } from 'react';

import { isLaunchpadSupported, launchpadDefinitions } from '@/constants/launchpads';

import { fontStyles } from '@/styles/typography';

import { LaunchpadAvatar } from '@/ui/Avatars/LaunchpadAvatar';
import { Tooltip } from '@/ui/Tooltip';

type TokenLaunchpadBadgeProps = {
  /** ID of the launchpad */
  id: string;
  /** Additional classes for the component */
  className?: string;
};

export const TokenLaunchpadBadge = ({ className, id }: TokenLaunchpadBadgeProps) => {
  const launchpadName = isLaunchpadSupported(id) ? launchpadDefinitions[id].name : id;
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  return (
    <Tooltip.Provider>
      <Tooltip.Root open={isTooltipOpen} onOpenChange={setIsTooltipOpen}>
        <Tooltip.Trigger asChild>
          <button
            type="button"
            aria-label={`Launchpad: ${launchpadName}`}
            onClick={(event) => {
              event.preventDefault();
              setIsTooltipOpen((isOpen) => !isOpen);
            }}
            className={fontStyles({
              variant: 'LABEL_SM',
              class: [
                'max-w-full min-w-0 items-center rounded-2xl flex justify-center h-6 px-2.5 gap-1.5',
                'outline-none bg-token-alphalight-300 hover:bg-token-alphalight-400',
                'active:bg-token-alphalight-400 focus-visible:outline-token-alphalight-500',
                'focus-visible:outline-2 focus-visible:outline-solid cursor-pointer',
                className,
              ],
            })}
          >
            <LaunchpadAvatar id={id} alt="" size={16} />
            <span className="min-w-0 overflow-hidden text-ellipsis whitespace-nowrap">
              {launchpadName}
            </span>
          </button>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content sideOffset={8}>{`Launched on ${launchpadName}`}</Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};
